export default "__VITE_ASSET__f0673aa3__"